<template>
  <div v-if="item" :class="{'mt-11' : !$mq.isDesktop()}">
    <v-breadcrumbs >
      <span @click="historyBack" class="text-bold link-detail" style="color: var(--quomi-primary)">
          <i class="fas fa-chevron-left mr-2"/>Torna indietro
      </span> 
    </v-breadcrumbs>
    <div class="row">
      <div class="col-md-8 col-xs-12">
        <div class="recipe-image" itemtype="http://schema.org/ImageObject">
          <div class="image-container">
            <img :src="!$mq.isDesktop() ? item.images.small : item.images.big" itemprop="image" class="img" :alt="item.name" rel="preload">
            <div style="text-align: right; font-size: 12px">* immagine a puro scopo illustrativo</div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xs-12">

        <div class="product-tags">
          <tags-line-orange
            :items="item.tags"
            class="section"
          />
          <span class="promo-button" v-if="item.price && item.discount.value > 0" >Promo</span>
        </div>   


        <div class="product-title mb-5">{{ item.title }}</div>
        <h3
          class="section extra-price d-flex flex-column"
          v-if="item.price && item.price != '0,00'"
        >
          <span v-if="item.price_type == 'portion'">
           + {{ item.price | priceFilter }} a porzione
          </span>
          <span v-if="item.price_type == 'global'">
            {{ item.price | priceFilter }}
          </span>
          <div class="d-flex align-items-center pt-2" v-if="item.price && item.discount.value > 0">
            <small class="text-danger text-bold"> - {{item.discount.value * 100}} %</small>
            <small class="px-3 text-muted">|</small>
            <small class="text-muted text-decoration-line-through">€ {{item.discount.original}}</small>
          </div>
        </h3>

        <div class="section" v-if="item.weight">
          <b>Peso: </b>
          <span>{{ item.weight }} g.</span>
        </div>

        <div class="my-5" >
          <router-link :to="{ name: 'flow-subscribed', query: {product_id: item.id} }" v-if="!item.shoppable">
            <CTA
              :content="'Fai la tua spesa'"
              isArrow
            />
          </router-link>
          <div v-if="item.shoppable">
            <cart-product :updating.sync="updating" :order="order" :item="item.original" :type='item.type' />
          </div>
        </div>
        
        <template v-if="item.preparation_time">
							<div class="recipe-block-usp">
								<div class="usp-inner-text">
									<div><i class="far fa-clock"></i></div>
									<div>
										<time :datetime="item.preparation_time_m" itemprop="totalTime">
											{{ $t("components.recipe.time") }} <br>{{ item.preparation_time }} {{ $t("general.minutes") }}
										</time>
									</div>
								</div>

								<!-- <div class="usp-inner-text" v-if="item.nutrition && item.nutrition.calories">
									<div>
										<i class="fas fa-fire" />
									</div>
									<div>Per porzione<br>{{ item.nutrition.calories.toFixed(1) }} Kcal</div>
									<div hidden><span itemprop="calories">{{ item.nutrition.calories * 1000 }}</span> Cal</div>
								</div> -->

							</div>
				</template>
        
        <!-- <template v-else>
          <div
            class="inline"
            v-if="item.preparation_time"
          >
            <i class="far fa-clock" /> {{ item.preparation_time }} {{ $t("general.minutes") }}&nbsp;
          </div>
        </template> -->

        <div v-if="item.supplier && item.supplier.name" class="section">
          <img src="../../assets/img/supplier-icon.png" class="supplier-icon"> {{ item.supplier.name }}
        </div>
        
        <div class="mt-5 section extra-description" v-if="item.description && $mq.isDesktop()">
          {{ item.description }}
        </div>

        <div class="mt-5 section extra-description" v-if="item.summary && !$mq.isDesktop()">
          {{ item.summary }}
        </div>

        <div class="match-btn tag-partner">
          <v-btn rounded outlined color="#399ec9" v-ripple class="mt-5 px-5 w-auto" @click="goDown()" v-if="item.type === 'recipe'">
            <img class="match-img pr-2" src="../../assets/img/badges/recipes/wine-glass.png" alt="abbinamenti">
            <span class="match-text">Scopri gli abbinamenti</span>
          </v-btn>
        </div>

        <!--
        <section-toggle
          :trigger.sync="showInfo"
          v-if="!$mq.isDesktop() && isToShowInfo(item)"
          class="section"
        >
          <template slot="title">
            <b>Informazioni aggiuntive</b>
          </template>

          <template slot="content" class="section">
            <div class="section" v-if='item.description' >
              <b>Ingredienti: </b>
              <span style='white-space: pre-wrap;'>{{ item.product.description }}</span>
            </div>

            <div class="section" v-if="item.allergens.length > 0">
              <b>Allergeni: </b>
              <div
                v-for="allergen, index in item.allergens"
                class="row-list"
              >
                {{ allergenName(allergen) }}</div>
            </div>

            <div class="section" v-if="item.nutrition && item.nutrition.calories">
              <div>
                <b>Kcal/Porzione: </b>
                <span>{{ item.nutrition.calories }} Kcal</span>
              </div>
            </div>


            <div class="section" v-if="item.volume">
              <b>Volume: </b>
              <span>{{ item.volume }}</span>
            </div>
          </template>
        </section-toggle>

        -->
        <!--
        <template class="section" v-if="$mq.isDesktop()">
          <div class="section" v-if='item.description'>
            <b>Ingredienti: </b>
            <span style='white-space: pre-wrap;'>{{ item.description }}</span>
          </div>

          <div class="section" v-if="item.allergens.length > 0">
            <b>Allergeni: </b>
            <div
              v-for="allergen, index in item.allergens"
              class="row-list"
            >
              {{ allergenName(allergen) }}</div>
          </div>

          <div class="section" v-if="pavesiniExtrasId.includes(item.id)">
            <router-link :to="{ name: 'pavesini' }" class="link-detail">
              Scopri di più
              </router-link>
            </div>

          <div class="section" v-if="item.nutrition && item.nutrition.calories">
            <div>
              <b>Kcal/Porzione: </b>
              <span>{{ item.nutrition.calories }} Kcal</span>
            </div>
          </div>

          <div class="section" v-if="item.weight">
            <b>Peso: </b>
            <span>{{ item.weight }} g.</span>
          </div>

          <div class="section" v-if="item.volume">
            <b>Volume: </b>
            <span>{{ item.volume }}</span>
          </div>


        </template>
        -->
          

        </div>
      </div>


    <hr>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class='recipe-block-ingredient' v-if="item.ingredients && item.ingredients.length > 0">
          <div v-if="item.type === 'recipe'">
            <h2>{{ $t("components.recipe.what_we_send") }}</h2>
            <p>{{ $t("components.recipe.what_we_send_sub") }}</p>
          </div>
          <div v-if="item.type === 'extra'">
            <h2>Ecco i prodotti che riceverai</h2>
          </div>
          <div class="recipe-ingredient-list">

            <div class="badge-ingredient" v-for="(ingredient, index) in item.ingredients" :key="index">

              <template v-if="ingredient.isSpecial">
                <router-link :to="{ name: ingredient.link }" target="_blank">
                  <p class="label-special-ingredient">Scopri</p>
                  <img class="img-rounded" :src="!$mq.isDesktop() ? ingredient.images.small : ingredient.images.big" :alt="ingredient.name">
                </router-link>
              </template>

              <template v-else>
                <img class="img-rounded" :src="ingredient.images.small  || 'https://api.quomi.it/oldimg/placeholder-productables.jpeg'" :alt="ingredient.name">
              </template>

              <div class='badge-ingredient-name' itemprop='recipeIngredient'>
                {{ ingredient.name }}<!--<span v-if="showWeight(ingredient)"> &bull; <nobr>{{ ingredient.weight }} g</nobr>-->
                <span v-if="item.type === 'extra'">
<!--                   <span v-if="ingredient.weight > 0">
                     ({{ ingredient.quantity * ingredient.weight }} g)
                  </span> -->
                  <span>
                    ({{ ingredient.quantity }} pz)
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class='recipe-ingredient' v-if="item.products_at_home">
          <h2>{{ $t("components.recipe.what_you_should_have") }}</h2>
          <div class="recipe-home-list" v-html="item.products_at_home"></div>
        </div>
      </div>

      <!-- <div class="col-md-4 col-sm-12"  v-if="item.nutrition">

        <div v-if="item.description_content">
            <h2>Ingredienti</h2>
          <div  v-html="item.description_content"></div>
        </div>

        <template>
						<div class='recipe-block' itemprop="nutrition" itemscope itemtype="http://schema.org/NutritionInformation">
							<h2>Dichiarazione nutrizionale<small>*</small></h2>
							<div class="info-small-normal pb-5">Per singola porzione</div>

							<div class="nutrition">
								<div class="flex">
									<div>Energia</div>
									<div class='flex-right'>{{ recipeNutrition('calories') }} Kcal</div>
								</div>

								<div>
									<div class="flex">
										<div>Grassi</div>
										<div class='flex-right' itemprop="fatContent">{{ recipeNutrition('fat') }} g</div>
									</div>

									<div class="flex">
										<div>di cui acidi grassi saturi</div>
										<div class='flex-right' itemprop="saturatedFatContent">{{ recipeNutrition('saturates') }} g</div>
									</div>
								</div>

								<div>
									<div class="flex">
										<div>Carboidrati</div>
										<div class='flex-right' itemprop="carbohydrateContent">{{ recipeNutrition('carbohydrate') }} g</div>
									</div>
									<div class="flex">
										<div>di cui zuccheri</div>
										<div class='flex-right'  itemprop="sugarContent">{{ recipeNutrition('sugars') }} g</div>
									</div>
								</div>

								<div class="flex">
									<div>Fibre</div>
									<div class='flex-right' itemprop="fiberContent">{{ recipeNutrition('fibre') }} g</div>
								</div>

								<div class="flex">
									<div>Proteine</div>
									<div class='flex-right' itemprop="proteinContent">{{ recipeNutrition('protein') }} g</div>
								</div>

								<div class="flex">
									<div>Sale</div>
									<div class='flex-right'>{{ recipeNutrition('salt') }} g</div>
								</div>
							</div>
						</div>
					</template>
      </div>
      <hr class="w-100"> -->
      <div class="flex flex-column pl-2">
        <div class="recipe-block my-3" v-if="item.preparation">
        <h2>{{ $t("components.recipe.preparation") }}</h2>
        <div class="recipe-preparation" v-html='format(item.preparation)' itemprop="recipeInstructions"></div>
      </div>

      <div class="recipe-block mt-5" v-if="item.allergens && item.allergens.length > 0">
        <h2>Allergeni</h2>

        <div v-for="allergen in item.allergens" :key="allergen.id">
          <span v-text="allergenName(allergen)"></span>
        </div>
      </div>
      </div>
    </div>

    <div id="widget-section">
      <widget-placeholder :vars="{product: item}"/>
    </div>
    <hr>
    <div class="info-small mb-5" v-show="item.nutrition">*Le informazioni nutrizionali di Quomi si applicano solo agli ingredienti forniti da Quomi. Il processo di preparazione e gli ingredienti aggiunti a casa (elencati sotto "Cosa avere in dispensa") influiranno sui valori totali. </div>

    <div class="info-small">Origini, categorie, marchi di identificazione sanitari, modalità di confezionamento, lotti e scadenze: riportati su ciascun prodotto all’interno del box <span v-html="$root.source === 'bennet' ? 'Instacook.' : 'Quomi.'"/></div>

      <div class="info-small-normal">
        <p><br>
        Imballato per Quomi Srl<br>
        via A. Sangiorgio 12 - 20145 Milano<br>
        nello stabilimento di:<br>
        Via Privata Oglio 18/20, 20098 San Giuliano Milanese (MI)
        </p>
        <p><b>Conservare a temperatura max +4°C</b></p>
      </div>
  </div>
</template>

<script>
import { extraAction } from '../../mixins/extraAction'
import TagsLineOrange from '../Parts/TagsLineOrange'
import SectionToggle from '../Parts/SectionToggle'
import Flash from '../Parts/Flash'
import CartProduct from './CartProduct'
import WidgetPlaceholder from '../WidgetPlaceholder'
import { scrollToElementId } from '../../assets/js/main'

export default {

  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'product'
    },
    action: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showInfo: false,
      flash: null,
      state: null,
      pavesiniExtrasId: [2464, 2465, 2466, 2461, 2460, 2454]
    }
  },

  mixins: [
    extraAction
  ],

  components: {
    CartProduct,
    TagsLineOrange,
    SectionToggle,
    Flash,
    WidgetPlaceholder
  },

  filters: {
    priceFilter (val) {
      return `€ ${val.replace('.', ',')}`
    }
  },
  computed: {
    user() {
      return this.$root.user;
    },
    order() {
      return this.user ? this.user.order : null
    }
  },
  methods: {
    format (text) {
      function insertBeforeAndAfterFirstOccurrence (strToSearch, strToFind, strToInsertBefore, strToInsertAfter) {
        var n = strToSearch.indexOf(strToFind)
        if (n < 0) { return strToSearch }
        return strToSearch.substring(0, n) + strToInsertBefore + strToSearch.substring(n, n + strToFind.length).slice(0, -1) + strToInsertAfter + strToSearch.substring(n + strToFind.length)
      }

      var result = text

      if (!result) return

      var array = []

      for (let i = 0; i < 99; i++) {
        let s = i + '.'
        array.push(s)
      }

      var before = '<div class="prep-step"><span>'
      var after = '</span></div>'

      array.forEach(item => {
        result = insertBeforeAndAfterFirstOccurrence(result, item, before, after)
      })

      return result
    },

    isToShowInfo (item) {
      return item.product.description || item.product.allergens.length > 0 || (item.product.nutrition && item.product.nutrition.calories) || item.product.weight || item.product.volume
    },
    allergenName (allergen) {
      return this.$t('components.recipe.allergens.' + allergen.name.toLowerCase().replace(/\s+/g, '_'))
    },

    recipeNutrition (nutrition) {
			return +this.item.nutrition[nutrition].toFixed(1)
		},

    toggleSection () {
      this.showInfo = !this.showInfo
    },

    goDown() {
      scrollToElementId("widget-section",  300, 100)
    },

    historyBack() {
            return history.back()
        }
  }
}

</script>

<style scoped>

  .recipe-image {
    position: relative;
    overflow: hidden;
  }

  h3 {
    text-align: left;
  }
  .orange {
    color: var(--quomi-orange);
  }


  .product-title {
    font-size: 24px;
    font-weight: bold;
    margin-top: 0;
    text-align: left;
  }

  .btn {
    margin: 0;
    border-radius: 4px;
  }

  .btn.full {
    width: 250px;
  }

  .row-list {
    display: inline-block;
  }

  .row-list:not(:last-child)::after {
    content: ', ';
    white-space: pre;
  }

  .section + .section {
    margin-top: 20px;
  }

  .info .section {
    margin-top: 20px;
  }

  .flash {
    height: 20px;
    margin-top: 5px;
  }

  .tags > span {
    background: orange;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 0px 5px;
    margin-right: 10px;
    margin-top: 2px;
  }

  .flex > div {
    flex-basis: 50%;
  }

  .extra-img {
    z-index: -1;
    padding-bottom: 0 !important;
  }

  .extra-img.image {
    height: 100%;
  }

  .extra-img.image >>> img {
    height: 100%;
      width: auto;
      max-width: inherit;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      padding: 10px 0;
  }

  .extra-action {
    display: flex;
    flex-wrap: nowrap;
    font-weight: bold;
    align-items: center;
  }

  .extra-action .label {
    margin-right: 10px;
  }

  .extra-action .flex-right {
    display: flex;
  }

  .extra-action button {
    padding: 5px;
    background-color: var(--quomi-primary);
    color: white;
    border: 1.5px solid var(--quomi-primary);
  }

  .extra-action .btn:not(.full) {
    font-size: 18px;
    padding: 3px 20px;
  }

  .extra-action button.full {
    background-color: var(--quomi-primary);
    color: white;
  }

  .extra-action .quantity-extra {
    padding: 5px 20px;
    z-index: 1;
  }

  .extra-title {
    margin-top: 10px;
  }

  .extra-price {
    font-size: 22px;
    font-weight: bold;
  }

  .supplier-icon {
    width: 15px;
    padding-bottom: 3px;
  }

  .recipe-block-nutrition-tags span {
	display: inline-block;
	color: #575A5C;
	text-transform: lowercase;
	padding-right: 5px;
}

.recipe-block-nutrition-tags span:not(:last-of-type)::after {
	content: ', ';
}

.recipe-block-usp {
	margin-top: 23px;
	border-top: 1px solid #ededed;
	border-bottom: 1px solid #ededed;
	display: flex;
	justify-content:space-between;
}

.recipe-block-usp > div  {
	flex-basis: 48%;
	padding: 15px 0;
	position: relative;
}

.recipe-block-usp > .usp-inner-text {
	text-align: center;
}

  @media (max-width: 1024px) {
    .extra-content.flex {
      flex-direction: column;
    }
    .flex > div {
      flex-basis: 100%;
    }

    .extra-img.image {
      min-height: 200px;
      
    }

    .extra-img.image >>> img {
      padding: 0px 0;
    }

  }

.recipe-ingredient-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.badge-ingredient {
  margin: 10px;
  position: relative;
  max-width: 180px;
  width: calc(100% / 2 - 20px);
}

.badge-ingredient-name {
  white-space: normal;
  word-break: break-word;
  display: block;
  margin-top: 5px;
  font-size: 15px;
}

.label-special-ingredient {
  font-weight: bold;
  color: white;
  position: absolute;
  background-color: orange;
  top: 0;
  width: 100%;
  text-align: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.label-special-ingredient a {
  color: white;
}
.recipe-home-list,
.recipe-preparation,
.recipe-block-description  {
  line-height: 2;
  white-space: pre-line;       /* css-3 */
  white-space: -moz-pre-line;  /* Mozilla, since 1999 */
  white-space: -pre-line;      /* Opera 4-6 */
  white-space: -o-pre-line;    /* Opera 7 */
  word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

.preparation-step {
  color: white;
  display: inline-block;
  background: blue;
  border-radius: 50%;
}

.product-tags {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
}

.promo-button {
    padding: 0 7px;
    border-radius: 5px;
		text-transform: uppercase;
    font-size: 13.5px;
		font-weight: bold;
    background: red;
    color: white;
	}

.match-btn:focus {
  outline: none;
}

.match-img {
  width: 2rem;
}

@media( max-width: 768px) {
  .match-text {
    font-size: smaller;
  }
  .recipe-block >>> h2 {
    font-size: 19.9px;
  }
}

</style>
